import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";

/**
 * FeaturedLinks — "Il mondo di OP": card con link verso siti esterni
 * (altri tornei, canale Telegram, pagina Facebook…). Immagine presa
 * automaticamente dal sito (Open Graph) o impostata a mano dall'admin.
 */
export default function FeaturedLinks() {
    const [links, setLinks] = useState([]);

    useEffect(() => {
        api.get("/featured-links").then((r) => setLinks(r.data || [])).catch(() => {});
    }, []);

    if (links.length === 0) return null;

    // Card sempre su una sola riga: colonne = numero di card (max 4).
    const colClass = {
        1: "lg:grid-cols-1",
        2: "lg:grid-cols-2",
        3: "lg:grid-cols-3",
        4: "lg:grid-cols-4",
    }[Math.min(links.length, 4)] || "lg:grid-cols-4";
    // Per poche card riduco la larghezza così non diventano enormi.
    const widthClass = links.length <= 2 ? "max-w-4xl" : links.length === 3 ? "max-w-6xl" : "max-w-7xl";

    return (
        <section className={`${widthClass} mx-auto px-4 sm:px-6 lg:px-8 pt-16`} data-testid="featured-links-section">
            <div className="op-label mb-5" style={{ color: "rgb(var(--tc-2bb6ff))" }}>// IL MONDO DI OP</div>
            <div className={`grid grid-cols-1 sm:grid-cols-2 ${colClass} gap-5`} data-testid="featured-links">
            {links.map((l) => (
                <a
                    key={l.id}
                    href={l.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group op-card overflow-hidden flex flex-col hover:border-t2bb6ff/60 transition-colors duration-200"
                    data-testid={`featured-link-${l.id}`}
                >
                    <div className="relative aspect-[1.91/1] bg-t0a0b0d overflow-hidden flex items-center justify-center">
                        {l.image_url ? (
                            <img
                                src={l.image_url}
                                alt={l.title}
                                className="w-full h-full object-contain group-hover:scale-[1.03] transition-transform duration-300"
                                onError={(e) => { e.currentTarget.style.display = "none"; }}
                            />
                        ) : (
                            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-t16181c to-t0a0b0d">
                                <span className="op-heading text-3xl text-t22252a">OP</span>
                            </div>
                        )}
                    </div>
                    <div className="p-4 flex flex-col flex-1">
                        <div className="op-heading text-tffffff text-base leading-tight">{l.title}</div>
                        {l.description && (
                            <p className="text-t8f95a3 text-sm mt-2 leading-relaxed line-clamp-3 flex-1">{l.description}</p>
                        )}
                        <span className="mt-4 inline-flex items-center justify-center gap-2 op-btn op-btn-primary text-xs self-start">
                            {l.button_text}
                            <ExternalLink className="w-3.5 h-3.5" />
                        </span>
                    </div>
                </a>
            ))}
            </div>
        </section>
    );
}
